import { useState } from 'react';
import 'photoswipe/dist/photoswipe.css';
import { Gallery, Item } from 'react-photoswipe-gallery';
import styled from 'styled-components';
import { Box } from '@bigcommerce/big-design';
import { useAsyncEffect } from '../../../../hooks';
import { ReactComponent as CrossIcon } from '../../../../icons/cross.svg';

const ImageThumbnail = styled.div`
	display: inline-block;
	position: relative;
	padding: 10px;
	width: 200px;
	height: 150px;
	cursor: pointer;

	background-position: center;
	background-size: cover;
	background-image: url(${({ src }) => src});
`;

const CloseIcon = styled.div`
	position: absolute;
	top: -12px;
	right: -12px;
`;

const GalleryWrapper = styled(Box)`
	display: flex;
	gap: 20px;
`;

function getImageDimensions(imageSource) {
	return new Promise((resolve) => {
		const img = new Image();
		img.onload = () => resolve({ width: img.width, height: img.height });
		img.src = imageSource;
	});
}

export function PhotosList({ photos, onRemovePhoto }) {
	if (photos.length <= 0) return null;

	const [images, setImages] = useState([]);

	// Get height and width of images for Gallery
	useAsyncEffect(
		async () => {
			setImages(
				await Promise.all(
					photos.map(async (photo) => {
						const img = await getImageDimensions(photo);

						return {
							path: photo,
							width: img.width !== 0 ? img.width : 600,
							height: img.height !== 0 ? img.height : 600,
						};
					}),
				),
			);
		},
		null,
		[photos],
	);

	return (
		<GalleryWrapper marginBottom="xxxLarge">
			<Gallery>
				{images.map((photo, index) => (
					<Item
						key={index}
						original={photo.path}
						thumbnail={photo.path}
						width={photo.width}
						height={photo.height}
					>
						{({ ref, open }) => (
							<ImageThumbnail
								src={photo.path}
								onClick={open}
								ref={ref}
							>
								<CloseIcon
									onClick={(event) => {
										event.preventDefault();
										event.stopPropagation();
										return onRemovePhoto(photo.path);
									}}
								>
									<CrossIcon />
								</CloseIcon>
							</ImageThumbnail>
						)}
					</Item>
				))}
			</Gallery>
		</GalleryWrapper>
	);
}

export function PhotoLinksList({ photos }) {
	if (photos.length <= 0) return null;

	return (
		<Box>
			{photos.map((photo, index) => (
				photo.startsWith('data:image/') ? null : (
					<Box key={index}>
						<a href={photo} target="_blank" rel="noopener noreferrer">{photo}</a>
					</Box>
				)
			))}
		</Box>
	);
}
